import { Modal, Input } from '@chikara/ui';
import { sanitizeAlphanumeric } from '@chikara/utils';
import { t } from '@/i18n';
import styles from '../../pages/CardDetailPage/CardDetailPage.module.css';

interface EditAliasModalProps {
    isOpen: boolean;
    value: string;
    onClose: () => void;
    onChange: (value: string) => void;
    onSave: () => void;
}

export const EditAliasModal = ({
    isOpen,
    value,
    onClose,
    onChange,
    onSave,
}: EditAliasModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('dashboard.card.detail.modals.editAlias.title')}
            description={
                <div className={styles.editAliasContent}>
                    <p className={styles.editAliasDescription}>
                        {t('dashboard.card.detail.modals.editAlias.description')}
                    </p>
                    <Input
                        label={t('dashboard.card.detail.modals.editAlias.label')}
                        value={value}
                        onChange={(e) => {
                            onChange(sanitizeAlphanumeric(e.target.value));
                        }}
                        size="md"
                        autoFocus
                    />
                </div>
            }
            actionLabel={t('dashboard.card.detail.modals.editAlias.save')}
            onAction={onSave}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            showCloseButton={true}
        />
    );
};
